// reward link

export const GET_REWARD_LINK_ASYNC = 'GET_REWARD_LINK_ASYNC'

export const FETCH_REWARD_LINK_BALANCE = 'FETCH_REWARD_LINK_BALANCE'

export const UPDATE_REWARD_LINK_BALANCE = 'UPDATE_REWARD_LINK_BALANCE'

export const UPDATE_BALANCE = 'UPDATE_BALANCE'

export const UPDATE_LONGEST_SCROLL = 'UPDATE_LONGEST_SCROLL'

// app

export const APP_SET_DISCLAIMER = 'APP_SET_DISCLAIMERS'

// cart

export const ADD_CART_ITEM = 'ADD_CART_ITEM'

export const REMOVE_CART_ITEM = 'REMOVE_CART_ITEM'

export const UPDATE_ITEM_VALUE = 'UPDATE_ITEM_VALUE'

export const SET_CART_EXTERNAL_REF_ID = 'SET_CART_EXTERNAL_REF_ID'

export const SET_SHOW_CART = 'SET_SHOW_CART'

export const RESET_CART = 'RESET_CART'

// order

export const FETCH_ORDER_VALIDATION = 'FETCH_ORDER_VALIDATION'

export const PLACE_ORDER = 'PLACE_ORDER'

export const PROCESS_ORDER_RESPONSE = 'PROCESS_ORDER_RESPONSE'

export const SET_ORDER_CONFIRMATION = 'SET_ORDER_CONFIRMATION'

// recipient data

export const FETCH_SPECIFIC_RL_RECIPIENT_DATA =
  'FETCH_SPECIFIC_RL_RECIPIENT_DATA'

export const SET_RECIPIENT_DATA = 'SET_RECIPIENT_DATA'

export const UPDATE_DIGITAL_RECIPIENT_DATA = 'UPDATE_DIGITAL_RECIPIENT_DATA'

export const UPDATE_PHYSICAL_RECIPIENT_DATA = 'UPDATE_PHYSICAL_RECIPIENT_DATA'

// catalog

export const SET_CATALOG = 'SET_CATALOG'

export const SET_CATALOG_SEARCH_PARAMS = 'SET_CATALOG_SEARCH_PARAMS'

export const SET_SEARCH_IS_VISIBLE = 'SET_SEARCH_IS_VISIBLE'

// feedback

export const ADD_PARTICIPATED_SURVEY = 'ADD_PARTICIPATED_SURVEY'

// redemption history

export const FETCH_REDEMPTION_HISTORY = 'FETCH_REDEMPTION_HISTORY'

export const RESET_REDEMPTION_HISTORY = 'RESET_REDEMPTION_HISTORY'

export const RESEND_REWARD = 'RESEND_REWARD'

// wallet

export const CLEAR_RECIPIENT_DETAILS = 'CLEAR_RECIPIENT_DETAILS'

export const FETCH_RECIPIENT_DETAILS = 'FETCH_RECIPIENT_DETAILS'

export const LOGIN = 'LOGIN'

export const REGISTER_RECIPIENT = 'REGISTER_USER'

export const REFRESH_AUTH_TOKEN = 'REFRESH_AUTH_TOKEN'

export const DELETE_RECIPIENT_WALLET = 'DELETE_RECIPIENT_WALLET'

// Direct Payments

export const SET_DIRECT_PAYMENT_AMOUNT = 'SET_DIRECT_PAYMENT_AMOUNT'

export const SET_DIRECT_PAYMENT_SESSION_ID = 'SET_DIRECT_PAYMENT_SESSION_ID'

export const SET_DIRECT_PAYMENT_TYPE = 'SET_DIRECT_PAYMENT_TYPE'

export const SET_DIRECT_PAYMENT_UTID = 'SET_DIRECT_PAYMENT_UTID'
